import Vue from "vue";
import Router from "vue-router";

const HomePage = resolve => require(["@/views/index"], resolve);
const Pselection = resolve => require(["@/views/pselection"], resolve);
const Rule = resolve => require(["@/views/rule"], resolve);
const Blindprize = resolve => require(["@/views/blindprize"], resolve);
const Livebroadcast = resolve => require(["@/views/livebroadcast"], resolve);
const RankingList = resolve => require(["@/views/rankingList"], resolve);
const Myprize = resolve => require(["@/views/myprize"], resolve);
const Invitation = resolve => require(["@/views/invitation"], resolve);
const Tgspecialarea = resolve => require(["@/views/tgspecialarea"], resolve);

Vue.use(Router);

// 不需要权限的路由
export const constantRouterMap = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage
  },
  {
    path: "/index",
    name: "HomePage",
    component: HomePage
  },
  {
    path: "/pselection",
    name: "Pselection",
    component: Pselection
  },
  {
    path: "/rule",
    name: "Rule",
    component: Rule
  },
  {
    path: "/blindprize",
    name: "Blindprize",
    component: Blindprize
  },
  {
    path: "/livebroadcast",
    name: "Livebroadcast",
    component: Livebroadcast
  },
  {
    path: "/rankingList",
    name: "RankingList",
    component: RankingList
  },
  {
    path: "/myprize",
    name: "Myprize",
    component: Myprize
  },
  {
    path: "/invitation",
    name: "Invitation",
    component: Invitation
  },
  {
    path: "/tgspecialarea",
    name: "Tgspecialarea",
    component: Tgspecialarea
  },
];

const router = new Router({
  routes: constantRouterMap,
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else {
  //     return { x: 0, y: 0 };
  //   }
  // }
  scrollBehavior: () => ({ y: 0 })
});

// 实例化vue的时候只挂载constantRouter
export default router;
